const jobs = [
      {
      company: 'AMGS',
      role: 'Salesforce Intern, Apr 2025 – Present',
      logo: 'amgs.png',
      link: 'https://example.com/amgs',
      description: 'Working on the Modon Real Estate onboarding project, building LWC components for login and registration pages with styling hooks and Jest testing. Assisted in creating sample dashboards using Power BI and Salesforce data, and used Data Loader and SOQL to extract field-level permissions across objects.'
    },
    {
      company: 'Kastech',
      role: 'Data Migration Intern, Feb 2025 – Present',
      logo: 'kastech.png',
      link: 'https://example.com/kastech',
      description: 'Supporting the migration of PeopleSoft applications from on-premise to cloud (OCI, Azure, AWS) by creating detailed migration timelines and documenting strategies, data integrity methods etc. and reverse migration scenarios, incorporating industry case studies and best practices.'
    },    
    {
      company: 'AI Minds India',
      role: 'Data Intern (2024)',
      logo: 'aiminds.png',
      link: 'https://example.com/aiminds',
      description: 'Worked with Azure services like Data Factory, Data Lake, Databricks, SQL DB and Event Hubs. Built data science models using pandas, matplotlib, sklearn.'
    },
    {
      company: 'Smaartt Consulting',
      role: 'Salesforce Intern (2023)',
      logo: 'smaartt.png',
      link: 'https://example.com/smaartt',
      description: 'Developed custom objects, flows, validation rules, dashboards, and contract generation in Salesforce.\n Worked with docomotion and process builder to streamline contract generation. '
    },
    {
      company: 'Indicurate Dubai',
      role: 'Web Dev Intern (2024)',
      logo: 'indicurate.png',
      link: 'https://example.com/indicurate',
      description: 'Created a dynamic fashion e-commerce site using HTML, CSS, JS, Ruby and Bootstrap on Shopify.'
    },
    {
      company: 'iCodeJr. Dubai',
      role: 'Curriculum Intern (2023)',
      logo: 'icodejr.png',
      link: 'https://example.com/icodejr',
      description: 'Built educational content and projects for learners using HTML, CSS, JS, and Python.'
    }
  ];

  

export default function Experience() {
  return (
    <section className="bg-gray-800 text-white py-12 px-4">
      <h2 className="text-3xl font-bold mb-8 text-center">Experience</h2>
      <div className="grid md:grid-cols-2 gap-4">
        {jobs.map((job) => (
          <div className="bg-white shadow-md p-4 rounded" key={job.title}>
            <h3 className="text-xl font-semibold">{job.title} @ {job.company}</h3>
            <p className="text-sm text-gray-500">{job.date}</p>
            <p className="mt-2">{job.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
